'use strict';

define('BetSlipAlertBannerDir',[],function() {

    /**
     * Available types:
     *  - warning (yellow background)
     *  - error (red background)
     *  - success (green background)
     *  - info (blue background)
     *  - neutral (default, yellowish background)
     *
     * @example
     *   <betslip-alert-banner
     *     type='warning'
     *     closeable='true'
     *     close='closeBanner()'>Lorem ipsum dolor sit amet, consectetur adipisicing elit
     *   </betslip-alert-banner>
     */
    return function BetSlipAlertBanner() {
        return {
            restrict: 'E',
            scope: {
                close: '&',
                type: '@',
                closeable: '@',
                message: '@'
            },
            templateUrl: 'js/modules/BetSlipWindow/templates/betslip-alert-banner.html',
            link: function(scope, element, attrs) {
                attrs.$observe('closeable', function() {
                    scope.closeable = scope.$eval(attrs.closeable);
                });
            }
        };
    };
});

